import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  TimePicker,
  Select,
  message,
  Popconfirm,
  Dropdown,
  Menu,
  DatePicker,
  Divider,
  Space,
  Radio,
} from "antd";
import {
  CloseOutlined,
  QuestionCircleOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import moment from "moment";
import "./CalendarEventModal.css";
import { generateTimeSlotsFromNow } from "../Common/CommonFunction";
import { Config } from "../Common/Config";
import axios from "axios";
import { spacerData } from "./CommonApiCallCalender";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import LantumProductAvailability from "./LantumProductAvailability";

const { RangePicker } = TimePicker;
const { Option } = Select;
const startSlots = [
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
]
const endSlots = [
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
]

const CalendarEventModal = (props) => {
  let userTempData = JSON.parse(localStorage.getItem("userData"));
  // console.log('::::::propsCalendarEventModal :::::::', props)
  const [form] = Form.useForm();
  const [endTime, setendTime] = useState(null);
  const [startTimeData, setstartTimeData] = useState(
    props?.spacerAndLunch?.start_time
      ? moment.utc(props.spacerAndLunch.start_time).format("HH:mm")
      : null
  );
  const [startTimedropDwonDataData, setstartTimedropDwonDataData] =
    useState(null);
  const [lantumStartAndEndTime, setlantumStartAndEndTime] = useState(
    props.lantumStartAndEndDate
  );
  const [startDate, setstartDate] = useState(
    props?.spacerAndLunch?.date ? dayjs(props?.spacerAndLunch?.date) : null
  );
  const [selectRoom, setselectRoom] = useState(null); //props?.spacerAndLunch?.room_id ??
  const [messageApi, contextHolder] = message.useMessage();

  // Filtered time slots based on current time
  const [filteredStartSlots, setFilteredStartSlots] = useState(startSlots);
  const [filteredEndSlots, setFilteredEndSlots] = useState(endSlots);

  // NEW STATE: For update confirmation modal
  const [showUpdateConfirmation, setShowUpdateConfirmation] = useState(false);
  const [updateScope, setUpdateScope] = useState("single");
  const [pendingPayload, setPendingPayload] = useState(null);

  // NEW STATE: For update confirmation modal
  const [updateEvent, setUpdateEvent] = useState("single"); // Changed from updateScope to updateEvent
  const [exceptionDate, setExceptionDate] = useState(null); // New state for exception date

  // Repeat functionality state - ADD THESE
  const [repeatEvent, setRepeatEvent] = useState("none");
  const [showCustomDays, setShowCustomDays] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [repeatUntilType, setRepeatUntilType] = useState("never");
  const [repeatUntilDate, setRepeatUntilDate] = useState(null);
  const [drapdownData, setdrapdownData] = useState();
  const [errorPresent, seterrorPresent] = useState();
  const [deletionType, setDeletionType] = useState("single");
  const [deleteModal, setDeleteModal] = useState(false);
  const [roomLoading, setRoomLoading] = useState(false);
  const [calenderData, setcalenderData] = useState(
    props?.spacerAndLunch?.date
      ? moment(props?.spacerAndLunch?.date).format("YYYY-MM-DD")
      : null
  );

  // Constants for repeat functionality - ADD THESE
  const weekdays = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
  const repeatOptions = [
    { label: "None", value: "none" },
    { label: "Every day", value: "daily" },
    { label: "Every week", value: "weekly" },
    { label: "Every month", value: "monthly" },
    { label: "Every year", value: "yearly" },
    { label: "Custom...", value: "custom" },
  ];

  const repeatUntilOptions = [
    { label: "Never", value: "never" },
    { label: "On date", value: "date" },
  ];

  useEffect(() => {
    if (props.spacerAndLunch) {
      // Populate repeat event data
      setRepeatEvent(props.spacerAndLunch.repeat_event || "none");

      // Populate repeat until date if exists
      if (props.spacerAndLunch.repeat_until) {
        setRepeatUntilType("date");
        setRepeatUntilDate(dayjs(props.spacerAndLunch.repeat_until));
      } else {
        setRepeatUntilType("never");
        setRepeatUntilDate(null);
      }

      // Populate custom days if exists
      if (
        props.spacerAndLunch.repeat_weekdays &&
        props.spacerAndLunch.repeat_weekdays.length > 0
      ) {
        setSelectedDays(props.spacerAndLunch.repeat_weekdays);
      }
    }
  }, [props.spacerAndLunch]);

  // Handle repeat event changes - ADD THIS useEffect
  // useEffect(() => {
  //     setShowCustomDays(repeatEvent === 'custom');
  //     if (repeatEvent !== 'custom') {
  //         setSelectedDays([]);
  //     }
  //     console.log('Repeat event changed to:', repeatEvent);
  // }, [repeatEvent]);

  useEffect(() => {
    setShowCustomDays(repeatEvent === "custom");

    if (repeatEvent !== "custom") {
      setSelectedDays([]);
    } else if (
      repeatEvent === "custom" &&
      selectedDays.length === 0 &&
      props?.spacerAndLunch?.repeat_weekdays?.length > 0
    ) {
      // rehydrate only if empty
      const normalized = props.spacerAndLunch.repeat_weekdays.map(
        (d) => d.charAt(0).toUpperCase() + d.slice(1, 3)
      );
      setSelectedDays(normalized);
    }
  }, [repeatEvent, props?.spacerAndLunch]);

  // Toggle day selection for custom repeat - ADD THIS FUNCTION
  const toggleDaySelection = (day) => {
    if (selectedDays.includes(day)) {
      setSelectedDays(selectedDays.filter((d) => d !== day));
    } else {
      setSelectedDays([...selectedDays, day]);
    }
    // console.log('Selected days:', selectedDays);
  };

  // Format selected days for display - ADD THIS FUNCTION
  const formatSelectedDays = () => {
    if (selectedDays.length === 0) return "Select custom days";

    const dayNames = {
      Mon: "Mon",
      Tue: "Tue",
      Wed: "Wed",
      Thu: "Thu",
      Fri: "Fri",
      Sat: "Sat",
      Sun: "Su",
    };

    return selectedDays.map((day) => dayNames[day]).join(", ");
  };

  // NEW FUNCTION: Handle update confirmation
  const handleUpdateConfirmation = (payload) => {
    setPendingPayload(payload);
    setShowUpdateConfirmation(true);
  };

  // NEW FUNCTION: Submit with update scope
  const submitWithUpdateScope = () => {
    // console.log("Submitting with update scope:", updateScope);
    if (pendingPayload) {
      const finalPayload = {
        ...pendingPayload,
        update_type: updateEvent === "specific" ? "single" : updateEvent,
      };

      // Add exception_date if update_event is 'specific'
      if (updateEvent === "specific" && exceptionDate) {
        finalPayload.exception_date = dayjs(exceptionDate).format("YYYY-MM-DD");
      }
      props.callbackWithData(finalPayload);
      setShowUpdateConfirmation(false);
      setPendingPayload(null);
    }
  };

  useEffect(() => {
    let date = moment().format("dddd, Do MMMM, YYYY"); //YYYY-MM-DD
    // let date = moment().format("YYYY-MM-DD")//YYYY-MM-DD
    // console.log( date ,'lantumStartAndEndTime:::',startDate)
    if (selectRoom) {
      if (startTimeData) {
        let endtime;
        if (
          selectRoom &&
          lantumStartAndEndTime &&
          lantumStartAndEndTime[selectRoom] &&
          lantumStartAndEndTime[selectRoom].lantum_end_time
        ) {
          endtime = moment
            .utc(lantumStartAndEndTime[selectRoom].lantum_end_time)
            .format("HH:mm");
        }
        let EndTime = generateTimeSlotsFromNow({
          startTime: startTimeData,
          interval: 15,
          endHour: endtime ?? "20:00",
        });
        EndTime.shift();
        if (EndTime && EndTime.length) {
          setendTime(EndTime);
        }
      }
      if (
        startDate &&
        date &&
        date != startDate &&
        lantumStartAndEndTime &&
        selectRoom
      ) {
        let timeOnly, endtime;
        if (
          selectRoom &&
          lantumStartAndEndTime &&
          lantumStartAndEndTime[selectRoom] &&
          lantumStartAndEndTime[selectRoom].lantum_start_time
        ) {
          timeOnly = moment
            .utc(lantumStartAndEndTime[selectRoom].lantum_start_time)
            .format("HH:mm");
          endtime = moment
            .utc(lantumStartAndEndTime[selectRoom].lantum_end_time)
            .format("HH:mm");
        }
        // console.log('timeOnly:::', { timeOnly, endtime })
        let StartTime = generateTimeSlotsFromNow({
          startTime: timeOnly ?? "8:00",
          interval: 15,
          endHour: endtime ?? "20:00",
          date: startDate,
        });
        if (StartTime) {
          StartTime.pop();
          // console.log('StartTime lantumStartAndEndTime:::', StartTime, selectRoom)
          setstartTimedropDwonDataData(StartTime);
        }
      } else {
        let timeOnly, endtime;
        if (
          selectRoom &&
          lantumStartAndEndTime &&
          lantumStartAndEndTime[selectRoom] &&
          lantumStartAndEndTime[selectRoom].lantum_start_time
        ) {
          timeOnly = moment
            .utc(lantumStartAndEndTime[selectRoom].lantum_start_time)
            .format("HH:mm");
          endtime = moment
            .utc(lantumStartAndEndTime[selectRoom].lantum_end_time)
            .format("HH:mm");
        }
        // console.log('timeOnly:else::', { timeOnly, endtime })
        if (timeOnly) {
          const [hour, minute] = timeOnly.split(":").map(Number);
          const now = moment();
          const todayTime = moment().set({
            hour,
            minute,
            second: 0,
            millisecond: 0,
          });
          if (now.isAfter(todayTime)) {
            timeOnly = getRoundedTimeUp(15).format("HH:mm");
          }
        }
        // console.log('timeOnly sfds :::', timeOnly)
        let StartTime = generateTimeSlotsFromNow({
          startTime: timeOnly ?? "8:00",
          interval: 15,
          endHour: endtime ?? "20:00",
          date: startDate,
        });
        if (StartTime) {
          StartTime.pop();
          // console.log('StartTime sfds :::', StartTime)
          setstartTimedropDwonDataData(StartTime);
        }
      }
    }
  }, [startTimeData, startDate, selectRoom, form]);

  useEffect(() => {
    if (startDate && props.data.id) {
      getCsrlantumStartAndEndTime(startDate, props.data.id);
    }
  }, [startDate]);

  // Filter time slots based on current time if today is selected
  useEffect(() => {
    // If editing existing event, show all time slots
    if (props.spacerAndLunch) {
      setFilteredStartSlots(startSlots);
      setFilteredEndSlots(endSlots);
      return;
    }

    if (startDate) {
      // Handle both dayjs object and string
      let selectedDate;
      if (dayjs.isDayjs(startDate)) {
        selectedDate = startDate.format('YYYY-MM-DD');
      } else if (typeof startDate === 'string') {
        selectedDate = dayjs(startDate, 'dddd, Do MMMM, YYYY').format('YYYY-MM-DD');
      } else {
        selectedDate = dayjs(startDate).format('YYYY-MM-DD');
      }

      const today = dayjs().format('YYYY-MM-DD');

      console.log('Selected Date:', selectedDate, 'Today:', today); // Debug log

      if (selectedDate === today) {
        // Get current time in HH:mm format
        const currentTime = dayjs().format('HH:mm');
        console.log('Current Time:', currentTime); // Debug log

        // Filter start slots to show only current time and future slots
        const filteredStart = startSlots.filter(slot => slot >= currentTime);
        console.log('Filtered Start Slots:', filteredStart); // Debug log
        setFilteredStartSlots(filteredStart);

        // Filter end slots to show only current time and future slots
        const filteredEnd = endSlots.filter(slot => slot >= currentTime);
        setFilteredEndSlots(filteredEnd);
      } else {
        // If not today, show all slots
        setFilteredStartSlots(startSlots);
        setFilteredEndSlots(endSlots);
      }
    } else {
      // If no date selected, show all slots
      setFilteredStartSlots(startSlots);
      setFilteredEndSlots(endSlots);
    }
  }, [startDate, props.spacerAndLunch]);
  const getCsrlantumStartAndEndTime = async (date, id) => {
    setRoomLoading(true)
    console.log("::getCsrlantumStartAndEndTime::date :::", date, id);
    let data = {
      clinic_id: id ?? props.data.id,
    };
    // if (moment(date, "YYYY-MM-DD", true).isValid()) {
    //   data = {
    //     ...data,
    //     date: date,
    //   };
    // } else {
    //   data = {
    //     ...data,
    //     date: moment(date, "dddd, Do MMMM, YYYY").format("YYYY-MM-DD"),
    //   };
    // }

    const formattedDate = moment(date, [
      "YYYY-MM-DD",
      "DD MMM YYYY",
      "dddd, Do MMMM, YYYY",
      "D MMM YYYY",
    ]).format("YYYY-MM-DD");

    // If moment can’t parse, formattedDate will be "Invalid date" — handle gracefully
    if (formattedDate !== "Invalid date") {
      data.date = formattedDate;
    }
    // return
    let csrRoomData = await spacerData("csr-rooms", data);
    // console.log('csrRoomData :::', csrRoomData?.data.data)
    setdrapdownData(csrRoomData?.data?.data);
    setRoomLoading(false)
    let lantumStartAndEndDate = {};
    if (csrRoomData?.data?.data && csrRoomData?.data?.data.length) {
      csrRoomData?.data?.data.map((newData) => {
        if (newData && newData.rooms && newData.rooms) {
          let count = 1,
            data = [];
          newData.rooms.map((roomdata) => {
            if (
              roomdata &&
              roomdata.type &&
              roomdata.room_id &&
              roomdata.type === "lantum"
            ) {
              data.push({
                ...roomdata,
                clinic_id: id,
                room_name: newData?.room_name ?? "",
                room_type: newData?.room_type ?? "Non GP",
              });
              lantumStartAndEndDate[roomdata.room_id] = {
                ...roomdata,
                lantum_end_time: roomdata?.lantum_end_time,
                clinic_id: id,
                room_name: newData?.room_name ?? "",
                room_type: newData?.room_type ?? "Non GP",
              };
            }
          });
          if (data && data.length && data.length > 1) {
            data.map((a, i) => {
              if (i === 0) {
                lantumStartAndEndDate[a.room_id] = {
                  ...lantumStartAndEndDate[a.room_id],
                  lantum_start_time: a?.lantum_start_time,
                };
              }
              if (i == data.length - 1) {
                lantumStartAndEndDate[a.room_id] = {
                  ...lantumStartAndEndDate[a.room_id],
                  lantum_end_time: a?.lantum_end_time,
                };
              }
            });
          }
        }
      });
    }
    // console.log('lantumStartAndEndDate', lantumStartAndEndDate)
    // setlantumStartAndEndDate(lantumStartAndEndDate)
    setlantumStartAndEndTime(lantumStartAndEndDate);
    if (props?.spacerAndLunch?.room_id) {
      handleRoomSelect(props?.spacerAndLunch?.room_id);
      // console.log('data :handleRoomSelect::', props?.spacerAndLunch?.room_id)
      //  setselectRoom(props?.spacerAndLunch?.room_id)
    }
  };

  function getRoundedTimeUp(interval = 15) {
    const now = moment();
    const minutes = now.minutes();
    const addMinutes = interval - (minutes % interval);

    // If already on an interval (e.g., 16:00), don't add extra
    const rounded =
      minutes % interval === 0
        ? now.clone()
        : now.clone().add(addMinutes, "minutes");
    // console.log('rounded:::', rounded)
    return rounded.set({ second: 0, millisecond: 0 });
  }
  const handleStartTimeChange = (value) => {
    const availableEndSlots = filteredEndSlots.filter(
      (slot) => value && slot > value);
    setFilteredEndSlots(availableEndSlots);
    form.setFieldsValue({
      ...form.getFieldValue(),
      end_time: undefined,
    });

    setstartTimeData(value);
  };
  const handleStartdateChange = (date, dateString) => {
    setstartDate(date); // Store the dayjs object, not the string
    setstartTimedropDwonDataData(null);
    setendTime(null);
    setstartTimeData(null);
    setselectRoom(null);
    const currentValues = form.getFieldsValue();
    const preservedValues = {
      name: currentValues.name,
      date: currentValues.date,
    };
    if (props.spacerAndLunch) {
      props.callback({ type: false, modalClose: false, dataClear: true });
    }
    form.resetFields();
    form.setFieldsValue(preservedValues);
  };

  const onFinish = (values, type) => {
    console.log(values);

    if (values?.room_id && values?.room_id?.value) {
      values.room_id = values?.room_id?.value;
    }

    const combinedDateTime = moment(
      `${values.date} ${values.start_time}`,
      "YYYY-MM-DD HH:mm"
    );
    const now = moment();

    if (combinedDateTime < now) {
      messageApi.error({
        type: "error",
        content: `Past ${props.spacerAndLunch?.type?.toLowerCase()} can't be rescheduled.`,
      });
      return;
    }

    // const isValidFormat = moment(values.date, "YYYY-MM-DD", true).isValid();
    // const formattedDate = moment(values.date, "dddd, Do MMMM, YYYY");
    // let date = isValidFormat ? values.date : formattedDate.format("YYYY-MM-DD");
    // console.log(date, "date");

    dayjs.extend(customParseFormat);

    let date = values.date;

    // 🧠 Case 1: If it's already a Day.js object
    if (dayjs.isDayjs(date)) {
      date = date.format("YYYY-MM-DD");
    }
    // 🧠 Case 2: If it's a string
    else if (typeof date === "string") {
      // Try parsing multiple known formats
      const parsed = dayjs(date, [
        "dddd, Do MMMM, YYYY", // e.g. Friday, 7th November, 2025
        "DD MMM YYYY", // e.g. 07 Nov 2025
        "YYYY-MM-DD", // e.g. 2025-11-07
      ]);

      date = parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
    }
    // 🧠 Case 3: If it's something else (null, undefined, etc.)
    else {
      date = null;
    }

    console.log(date, "✅ final formatted date");

    let tempDate = getStartAndEndTimestamps(
      date,
      values.start_time,
      values.end_time
    );

    // if (props.data && props.data.id && props.data.rooms && props.data.rooms.length > 0 && userTempData.id && date) {
    //     let eventType = "";
    //     if (type === 'BLOCK') {
    //         eventType = 'block';
    //     } else if (type === 'LUNCH') {
    //         eventType = 'lunch';
    //     } else if (type === 'SPACER') {
    //         eventType = 'spacer';
    //     }

    //     let payload = {
    //         "name": values.name,
    //         "type": eventType,
    //         "clinic_id": props.data.id,
    //         "room_id": values.room_id ? values.room_id : props.data && props.data.roomId ? props.data && props.data.roomId : props.data.rooms[0].id,
    //         "csr_id": userTempData.id,
    //         "date": date,
    //         "start_time": tempDate.start_time,
    //         "end_time": tempDate.end_time,
    //         "repeat_event": repeatEvent,
    //     };

    //     if (props.spacerAndLunch && props.spacerAndLunch.id) {
    //         payload.typedata = 'update';
    //         payload.id = props.spacerAndLunch.id;

    //         // NEW: Check if we need to show confirmation for recurring event update
    //         if (repeatEvent !== 'none') {
    //             handleUpdateConfirmation(payload);
    //             return; // Don't proceed with normal submission
    //         }
    //     }

    //     // Handle repeat_until correctly
    //     if (repeatEvent !== 'none') {
    //         if (repeatUntilType === 'date' && repeatUntilDate) {
    //             payload.repeat_until = dayjs(repeatUntilDate).format('YYYY-MM-DD');
    //         } else {
    //             payload.repeat_until = null;
    //         }
    //     }

    //     // Handle custom weekdays
    //     if (repeatEvent === 'custom' && selectedDays.length > 0) {
    //     payload.repeat_weekdays = selectedDays.map(d => d.toLowerCase());
    //     }

    //     props.callbackWithData(payload);
    // }

    if (
      props.data &&
      props.data.id &&
      props.data.rooms &&
      props.data.rooms.length > 0 &&
      userTempData.id &&
      date
    ) {
      let eventType = type.toLowerCase();
      // if (type === 'BLOCK') {
      //     eventType = 'block';
      // } else if (type === 'LUNCH') {
      //     eventType = 'lunch';
      // } else if (type === 'SPACER') {
      //     eventType = 'spacer';
      // }

      let payload = {
        name: values.name,
        type: eventType,
        // type,
        clinic_id: props.data.id,
        room_id: values.room_id
          ? values.room_id
          : props.data?.roomId
            ? props.data.roomId
            : props.data.rooms[0].id,
        csr_id: userTempData.id,
        date,
        start_time: tempDate.start_time,
        end_time: tempDate.end_time,
        repeat_event: repeatEvent,
        calendar_date: calenderData,
      };

      // ✅ Always handle repeat_until
      if (repeatEvent !== "none") {
        if (repeatUntilType === "date" && repeatUntilDate) {
          payload.repeat_until = dayjs(repeatUntilDate).format("YYYY-MM-DD");
        } else {
          payload.repeat_until = null;
        }
      }

      // ✅ Always handle custom weekdays
      if (repeatEvent === "custom" && selectedDays.length > 0) {
        payload.repeat_weekdays = selectedDays.map((d) => d.toLowerCase());
      }
      console.log(payload, "payload");
      // return;

      // ✅ Now decide between create vs update
      if (props.spacerAndLunch?.id) {
        payload.typedata = "update";
        payload.id = props.spacerAndLunch.id;

        if (repeatEvent !== "none") {
          console.log("update-payload before confirmation:", payload);
          handleUpdateConfirmation(payload);
          return;
        }
      }
      props.callbackWithData(payload);
    }
  };

  function getStartAndEndTimestamps(date, startLabel, endLabel) {
    const extractTime = (label) => label.split(" ").slice(0, 2).join(" ");
    const startTimeStr = extractTime(startLabel);
    const endTimeStr = extractTime(endLabel);
    const startMoment = moment(`${date} ${startTimeStr}`, "YYYY-MM-DD hh:mm A");
    const endMoment = moment(`${date} ${endTimeStr}`, "YYYY-MM-DD hh:mm A");
    return {
      start_time: startMoment.format("YYYY-MM-DD HH:mm:ss.SSS"),
      end_time: endMoment.format("YYYY-MM-DD HH:mm:ss.SSS"),
    };
  }
  let layout = {
    labelCol: {
      style: {
        textAlign: "center",
        marrginLeft: "11px",
      },
      span: 8,
    },
    wrapperCol: {
      span: 16,
    },
  };
  function getTimeGap(startTime, endTime) {
    const [startHour, startMin] = startTime.split(":").map(Number);
    const [endHour, endMin] = endTime.split(":").map(Number);

    const start = new Date();
    start.setHours(startHour, startMin, 0, 0);

    const end = new Date();
    end.setHours(endHour, endMin, 0, 0);

    const diffMs = end - start;
    const diffMin = Math.floor(diffMs / 60000);

    const hours = Math.floor(diffMin / 60);
    const minutes = diffMin % 60;

    if (diffMin <= 0) return "0 min";

    if (hours > 0 && minutes > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""} ${minutes} min`;
    } else if (hours > 0) {
      return `${hours} hour${hours > 1 ? "s" : ""}`;
    } else {
      return `${minutes} min`;
    }
  }
  function getNext7DaysFormatted() {
    const days = [];
    for (let i = 0; i < 30; i++) {
      const date = moment().add(i, "days");
      const formatted = date.format("dddd, Do MMMM, YYYY");
      days.push(formatted);
    }
    return days;
  }
  const dateDropDown = getNext7DaysFormatted();
  const deleteSpacer = async () => {
    const now = moment();
    const inputDate = moment(props.spacerAndLunch.start_time);
    if (inputDate < now) {
      messageApi.error({
        type: "error",
        content: `Past ${props.spacerAndLunch?.type?.toLowerCase()} can't be delete.`,
      });
      return;
    }
    // return
    if (!props.spacerAndLunch.id) {
      return;
    }
    // let url = `${Config.url}spacer/${props.spacerAndLunch.id}`
    let url = `${Config.url}${props.spacerAndLunch.type == "lunch"
      ? "spacer"
      : props.spacerAndLunch.type
      }/${props.spacerAndLunch.id}`;
    try {
      const response = await axios.delete(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        data: {
          date: props?.spacerAndLunch?.date || null,
          delete_type: deletionType,
        },
      });
      messageApi.success({
        content: "Product deleted successfully",
      });
      props.callback({ type: true, modalClose: true });
    } catch (error) {
      messageApi.error({
        // type: 'error',
        content: error.message,
      });
      throw error;
    }
  };
  const handleRoomSelect = (room) => {
    setselectRoom(room);
  };
  const disabledPastDates = (current) => {
    const today = moment().startOf("day");
    // const maxDate = moment().add(30, "days").endOf("day");
    return (
      current &&
      (current.isBefore(today, "day"))
    );
  };
  const isLantumEvent = props?.spacerAndLunch?.type?.toLowerCase() === "lantum";

  return (
    <>
      <Modal
        title={
          <span style={{ color: "white" }}>
            {isLantumEvent
              ? "Clinician Product Availability"
              : `${props.type ? "Add " : "Edit"} ${props?.type?.toLowerCase() ?? "Information"}`}
          </span>
        }
        open={props.status}
        onCancel={() => props.callback({ type: false, modalClose: true })}
        closeIcon={
          <CloseOutlined style={{ color: "#fff", fontSize: "18px" }} />
        }
        className={isLantumEvent ? "custom-appointment-create-modal lantum-modal-override" : "custom-appointment-create-modal"}
        footer={null}
        style={isLantumEvent ? { top: "12%", paddingBottom: 0 } : { position: "absolute", right: 0, top: "12%" }}
        width={isLantumEvent ? "70%" : 600}
      >
        {contextHolder}
        {isLantumEvent ? (
          <LantumProductAvailability
            onClose={() => props.callback({ type: false, modalClose: true })}
            eventData={props.spacerAndLunch}
          />
        ) : (
          <Form
            autoComplete="off"
            {...layout}
            onFinish={(value) => onFinish(value, props?.type)}
            form={form}
            initialValues={
              props.spacerAndLunch
                ? {
                  name: props.spacerAndLunch?.name,
                  date: dayjs(props.spacerAndLunch?.date),
                  start_time: moment
                    .utc(props.spacerAndLunch?.start_time)
                    .format("HH:mm"),
                  end_time: moment
                    .utc(props.spacerAndLunch?.end_time)
                    .format("HH:mm"),
                  room_id: {
                    value: props.spacerAndLunch.room_id,
                    label: props?.data?.rooms.map((room, i) => {
                      if (room.id && room.id == props.spacerAndLunch.room_id) {
                        //  console.log(props.spacerAndLunch.room_id,':room::',room)
                        return `Room ${i + 1}`;
                      } else {
                        // console.log(props.spacerAndLunch.room_id,':room: else:',room)
                      }
                    }),
                  },
                }
                : null
            }
          >
            <Form.Item
              name="name"
              label="Title"
              rules={[{ required: true, message: "Title is required." }]}
            >
              <Input
                placeholder="Add Title"
                style={{
                  border: "1px solid #00000040",
                  color: "#000",
                  width: 209,
                  height: 30,
                }}
              />
            </Form.Item>

            {/* <Form.Item label="Date:" name='date' rules={[{ required: true, message: "Date selection is required." }]} >
                    <Select className="inputbox-custom-placeholder" placeholder='Select a date' style={{ width: 209, height: 30, textAlign: 'center' }} onChange={(value) => handleStartdateChange(value)}>
                        {dateDropDown?.map((item, index) => (
                            <Option key={index} value={item}>
                                {item}
                            </Option>
                        ))}
                    </Select>
                </Form.Item> */}
            <Form.Item
              label="Date:"
              name="date"
              rules={[{ required: true, message: "Date selection is required." }]}
            >
              <DatePicker
                className="inputbox-custom-placeholder"
                placeholder="Select a date"
                style={{ width: 209, height: 30, textAlign: "center" }}
                format="ddd, Do MMMM, YYYY"
                onChange={(date, dateString) => handleStartdateChange(date, dateString)}
                disabledDate={disabledPastDates}
              />
            </Form.Item>

            <Form.Item
              label="Room"
              name="room_id"
              rules={[{ required: true, message: "Date selection is required." }]}
            >
              <Select
                // disabled={lantumStartAndEndTime && Object.keys(lantumStartAndEndTime).length ? false : true}
                className="inputbox-custom-placeholder"
                placeholder="Room"
                style={{ width: 209, height: 30, textAlign: "center" }}
                onChange={(value) => handleRoomSelect(value)}
                loading={roomLoading}
              >
                {drapdownData?.length > 0 &&
                  drapdownData?.map((item, index) => (
                    <Option key={index} value={item.room_id}>
                      {item?.room_name}
                    </Option>
                  ))}
                {/* {lantumStartAndEndTime && Object.keys(lantumStartAndEndTime).length && Object.values(lantumStartAndEndTime)?.map((item, index) => (
                            <Option key={index} value={item.room_id}>
                                {item?.room_name ?? ''}{item.room_type ? `- ${item.room_type}` : ''}
                            </Option>
                        ))} */}
              </Select>
            </Form.Item>

            {/* Repeat Event Field */}
            <Form.Item label="Repeat event">
              <Select
                value={repeatEvent}
                onChange={setRepeatEvent}
                style={{ width: 209, height: 30 }}
              >
                {repeatOptions.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {/* Custom Days Field (only shown when repeatEvent is 'custom') */}
            {showCustomDays && (
              <Form.Item label="Custom">
                <Dropdown
                  trigger={["click"]}
                  overlay={
                    <Menu>
                      <div
                        style={{
                          padding: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            marginBottom: "10px",
                          }}
                        >
                          {weekdays.map((day, idx) => (
                            <div
                              key={idx}
                              onClick={() => toggleDaySelection(day)}
                              style={{
                                width: 22,
                                height: 22,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "2px",
                                borderRadius: 6,
                                cursor: "pointer",
                                backgroundColor: selectedDays.includes(day)
                                  ? "#008385"
                                  : "#f0f0f0",
                                color: selectedDays.includes(day)
                                  ? "#fff"
                                  : "#000",
                                userSelect: "none",
                              }}
                            >
                              {day[0]}
                            </div>
                          ))}
                        </div>
                      </div>
                    </Menu>
                  }
                >
                  <Button
                    style={{
                      width: 209,
                      textAlign: "left",
                      overflow: "hidden",
                      whiteSpace: "nowrap",
                      textOverflow: "ellipsis",
                      display: "block",
                    }}
                    title={formatSelectedDays()} // Shows full days on hover
                  >
                    {formatSelectedDays()}
                  </Button>
                </Dropdown>
              </Form.Item>
            )}

            {/* End Repeat Options (only shown when repeatEvent is not 'none') */}
            {repeatEvent !== "none" && (
              <>
                <Form.Item label="End repeat">
                  <Select
                    value={repeatUntilType}
                    onChange={setRepeatUntilType}
                    style={{ width: 209, height: 30 }}
                  >
                    {repeatUntilOptions.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                {repeatUntilType === "date" && (
                  <Form.Item label="End repeat date">
                    <DatePicker
                      value={repeatUntilDate}
                      // onChange={setRepeatUntilDate}
                      onChange={(date) => {
                        // console.log('Date selected oncahge:', date);
                        setRepeatUntilDate(date);
                      }}
                      style={{ width: 209 }}
                      format="DD/MM/YYYY"
                      disabledDate={(current) => {
                        return current && current < moment().startOf("day");
                      }}
                    />
                  </Form.Item>
                )}
              </>
            )}
            <Form.Item
              label="Start Time"
              name="start_time"
              rules={[
                { required: true, message: "Start Time selection is required." },
                {
                  validator: (_, value) => {
                    const date = form.getFieldValue("date");
                    if (!date) {
                      return Promise.reject(
                        new Error("Please select a date first.")
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Select
                className="inputbox-custom-placeholder"
                placeholder=" select Start Time"
                style={{ width: 209, height: 30, textAlign: "center" }}
                onChange={(value) => handleStartTimeChange(value)}
              >
                {filteredStartSlots &&
                  filteredStartSlots?.map((item, index) => (
                    <Option key={index} value={item}>
                      {item}
                    </Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="End Time"
              name="end_time"
              rules={[
                { required: true, message: "End Time selection is required." },
              ]}
            >
              <Select
                className="inputbox-custom-placeholder"
                placeholder=" select End Time"
                style={{ width: 209, height: 30, textAlign: "center" }}
              >
                {filteredEndSlots?.map((item, index) => (
                  <Option key={index} value={item}>
                    {item}{" "}
                    {startTimeData
                      ? `( ${getTimeGap(startTimeData, item)} )`
                      : ""}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Divider
              style={{
                margin: "auto",
                height: props?.ifError ? 0 : 25,
                borderColor: "rgba(0, 131, 133, 1)",
              }}
            />

            {props?.ifError && (
              <>
                <div style={{ color: "red", margin: "15px 10px " }}>
                  {props?.ifError}
                </div>
                <Divider
                  style={{
                    margin: "15px 0px",
                    height: props?.ifError ? 0 : 25,
                    borderColor: "rgba(0, 131, 133, 1)",
                  }}
                />
              </>
            )}

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              <div style={{ flex: "1 1 33%", textAlign: "center" }}>
                <Button
                  style={{ width: 100, height: 40 }}
                  key="save"
                  type="primary"
                  htmlType="submit"
                >
                  Save
                </Button>
              </div>
              {props.spacerAndLunch && (
                <Button
                  className="add-generic-btn"
                  style={{ width: 100, height: 40 }}
                  onClick={() => setDeleteModal(true)}
                >
                  Delete
                </Button>
              )}
              {/* {props.spacerAndLunch && <div style={{ flex: '1 1 33%', textAlign: 'center' }}>
                        <Popconfirm
                            title="Delete"
                            className='confirmation-popup'
                            description="Are you sure you want to delete?"
                            // onConfirm={() => deleteUser(record)}
                            onCancel={deleteSpacer}
                            icon={
                                <QuestionCircleOutlined
                                    style={{
                                        color: 'red',
                                    }}
                                />
                            }
                            okButtonProps={{ className: 'confirmation-popup-ok-button' }}
                            cancelButtonProps={{ className: 'confirmation-popup-cancel-button' }}
                            // okText="Yes"
                            // cancelText="No"
                            okText="No"
                            cancelText="Yes"
                        >
                        <Button className='add-generic-btn'  style={{ width: 100, height: 40 }} key="save"   >
                            Delete
                        </Button>
                        </Popconfirm>
                    </div>} */}

              <Modal
                title="Delete Confirmation"
                open={deleteModal}
                onCancel={() => setDeleteModal(false)}
                footer={[
                  <Button key="cancel" onClick={() => setDeleteModal(false)}>
                    Cancel
                  </Button>,
                  <Button
                    key="confirm"
                    //   type="primary"
                    onClick={deleteSpacer}
                    className="delete-button"
                    icon={<DeleteOutlined className="delete-icon" />}
                  >
                    Confirm Delete
                  </Button>,
                ]}
              >
                {contextHolder}
                <div style={{ padding: "0px 0" }}>
                  {/* <p>Are you sure you want to delete? Please select deletion scope:</p> */}

                  <Radio.Group
                    onChange={(e) => {
                      setDeletionType(e.target.value);
                      console.log("change suceessfully", e.target.value);
                    }}
                    value={deletionType}
                    style={{ width: "100%" }}
                  >
                    <Space direction="vertical" style={{ width: "100%" }}>
                      <Radio
                        value="single"
                        style={{ padding: "8px", width: "100%" }}
                      >
                        <div>
                          <div
                            style={{
                              fontFamily: "lato",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            This event
                          </div>
                          {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                    This event
                                    </div> */}
                        </div>
                      </Radio>
                      <Radio
                        value="all"
                        style={{ padding: "8px", width: "100%" }}
                      >
                        <div>
                          <div
                            style={{
                              fontFamily: "lato",
                              fontSize: "16px",
                              fontWeight: "500",
                            }}
                          >
                            This and following events
                          </div>
                          {/* <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                                    This and following events
                                    </div> */}
                        </div>
                      </Radio>
                    </Space>
                  </Radio.Group>
                </div>
              </Modal>
              <div style={{ flex: "1 1 33%", textAlign: "center" }}>
                <Button
                  className="add-generic-btn"
                  onClick={() =>
                    props.callback({ type: false, modalClose: true })
                  }
                  style={{ width: 100, height: 40 }}
                  key="save"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        )}
      </Modal>

      <Modal
        title="Update Recurring Event"
        open={showUpdateConfirmation}
        onCancel={() => setShowUpdateConfirmation(false)}
        footer={[
          <Button key="cancel" onClick={() => setShowUpdateConfirmation(false)}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" onClick={submitWithUpdateScope}>
            Confirm
          </Button>,
        ]}
      >
        <Radio.Group
          // onChange={(e) => setUpdateScope(e.target.value)}

          // value={updateScope}
          onChange={(e) => setUpdateEvent(e.target.value)}
          value={updateEvent}
          style={{ display: "flex", flexDirection: "column", gap: "10px" }}
        >
          <Radio value="single">This event</Radio>
          <Radio value="all">This and following events</Radio>
          {/* <Radio value="specific">For events on specific date</Radio> */}
        </Radio.Group>

        {/* Date picker for specific date option */}
        {/* {updateEvent === 'specific' && (
                    <div style={{ marginTop: '15px' }}>
                        <DatePicker
                            value={exceptionDate}
                            onChange={setExceptionDate}
                            style={{ width: '100%' }}
                            disabledDate={(current) => {
                                return current && current < moment().startOf('day');
                            }}
                            placeholder="Select exception date"
                        />
                    </div>
                )} */}
      </Modal>
    </>
  );
};

export default CalendarEventModal;
